import { render, staticRenderFns } from "./ClientContactPermissions.vue?vue&type=template&id=becebc8c"
import script from "./ClientContactPermissions.vue?vue&type=script&lang=js"
export * from "./ClientContactPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports